/**
 * Hộp hiển thị thông tin đăng nhập DV001 vừa cấp — MỘT LẦN DUY NHẤT.
 *
 * Mật khẩu chỉ sống trong trạng thái của hộp này: không ghi vào địa chỉ trang,
 * không lưu trình duyệt. Nút đóng chỉ bật khi người dùng xác nhận đã lưu, để không
 * lỡ tay đóng mất mật khẩu (muốn xem lại phải cấp lại, làm rớt kết nối đang có).
 */
import { useEffect, useId, useRef, useState, type ReactNode } from 'react';
import { viNhaCungCap } from '../ngon-ngu/vi-nha-cung-cap';
import type { TaiKhoanVuaCap } from '../api/nha-cung-cap-api';

async function saoChep(chuoi: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(chuoi);
    return true;
  } catch {
    return false;
  }
}

export function HopTaiKhoanVuaCap({
  taiKhoan,
  onDong,
}: {
  taiKhoan: TaiKhoanVuaCap;
  onDong: () => void;
}): ReactNode {
  const t = viNhaCungCap.taiKhoan;
  const [daLuu, datDaLuu] = useState(false);
  const [daChep, datDaChep] = useState<string | null>(null);
  const idTieuDe = useId();
  const oMatKhau = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    oMatKhau.current?.focus();
    oMatKhau.current?.select();
  }, []);

  const chep = async (khoa: string, chuoi: string): Promise<void> => {
    if (await saoChep(chuoi)) datDaChep(khoa);
  };

  const dong: [string, string, string][] = [
    ['dia-chi', t.diaChi, taiKhoan.diaChiXacThuc],
    ['ten', t.tenDangNhap, taiKhoan.tenDangNhap],
    ['mat-khau', t.matKhau, taiKhoan.matKhau],
  ];
  const tatCa = dong.map(([, nhan, gt]) => `${nhan}: ${gt}`).join('\n');

  return (
    <div className="man-che" role="presentation">
      <div className="hop-thoai ncc-tai-khoan" role="dialog" aria-modal="true" aria-labelledby={idTieuDe}>
        <h2 id={idTieuDe}>{t.tieuDe}</h2>
        <p className="ncc-tai-khoan__canh-bao" role="alert">
          {t.canhBao}
        </p>
        <dl className="ncc-tai-khoan__ds" data-vung="tai-khoan-vua-cap">
          {dong.map(([khoa, nhan, gt]) => (
            <div key={khoa} className="ncc-tai-khoan__dong">
              <dt>
                <label htmlFor={`tk-${khoa}`}>{nhan}</label>
              </dt>
              <dd>
                <input
                  id={`tk-${khoa}`}
                  ref={khoa === 'mat-khau' ? oMatKhau : undefined}
                  readOnly
                  value={gt}
                  spellCheck={false}
                  autoComplete="off"
                  onFocus={(e) => e.target.select()}
                />
                <button type="button" className="nut nut--nho" onClick={() => void chep(khoa, gt)}>
                  {daChep === khoa ? t.daSaoChep : t.saoChep}
                </button>
              </dd>
            </div>
          ))}
        </dl>
        <p>
          <button type="button" className="nut" onClick={() => void chep('tat-ca', tatCa)}>
            {daChep === 'tat-ca' ? t.daSaoChep : t.saoChepTatCa}
          </button>
        </p>
        <label className="ncc-tai-khoan__xac-nhan">
          <input type="checkbox" checked={daLuu} onChange={(e) => datDaLuu(e.target.checked)} />
          {t.daLuu}
        </label>
        <div className="man-hinh__hanh-dong">
          <button type="button" className="nut nut--chinh" disabled={!daLuu} onClick={onDong}>
            {viNhaCungCap.chung.dong}
          </button>
        </div>
      </div>
    </div>
  );
}
